import { render, staticRenderFns } from "./RatingDetail.vue?vue&type=template&id=64463286&scoped=true&"
import script from "./RatingDetail.vue?vue&type=script&lang=js&"
export * from "./RatingDetail.vue?vue&type=script&lang=js&"
import style0 from "./RatingDetail.vue?vue&type=style&index=0&id=64463286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64463286",
  null
  
)

export default component.exports